import { useCallback } from 'react';
import { useAnalyticsContext } from '../analytics/analytics.provider';
import { Entity, EventName, ContextTrackingMetadata } from '../types';

const GLOBAL_FILTER_TYPE = 'Selectors';

export const useContextTracking = () => {
  const { trackPageEvent } = useAnalyticsContext();

  const trackUpdates = useCallback(
    ({ tracking }: { tracking?: ContextTrackingMetadata }, updates: Record<string, Entity[]>) => {
      Object.keys(updates).forEach(key => {
        const entities = updates[key];
        if (entities.length) {
          trackPageEvent(EventName.FilterApplied, {
            filterName: key,
            filterType: GLOBAL_FILTER_TYPE,
            optionChosen: entities.map(entity => entity.label),
            optionChosenValues: entities.map(entity => entity.value),
          });
        }
      });

      if (tracking?.hasPageView) {
        trackPageEvent(EventName.PageViewed);
      }
    },
    [trackPageEvent]
  );

  return { trackUpdates };
};
